import React from "react";
import Settings from "./Settings";
import PageComponent from "../PageComponent";
import LanguageService from "../../../../services/LanguageService";
import PartyService from "../../../../services/PartyService";
import { selectFilter } from "../../../../services/FilteringUtils";
import LocalizationUtil from "../../../../localization/LocalizationUtil";
import UserSession from "../../../../session/UserSession";
import { labels } from "../../../../localization/labels";
import CommonUtil from "../../../../utils/CommonUtil";
import { messages } from "../../../../localization/messages";

class SettingsContainer extends PageComponent {
  constructor(props) {
    super(props);

    this.languageService = new LanguageService();
    this.partyService = new PartyService();

    this.state = this.initialState();
  }

  initialState() {
    return { party: undefined, oldParty: undefined, languages: [] };
  }

  componentDidMount() {
    this.loadLanguagesData();
    this.loadPartyData();

    this.performCalls();
  }

  loadLanguagesData = () => {
    const pageInfo = {
      filters: {
        isoCodes: selectFilter(LocalizationUtil.possibleLanguages)
      }
    };
    const sortInfo = { orderBy: "name", direction: "asc" };
    this.prepareCall(
      this.languageService.getEntities(
        pageInfo,
        sortInfo,
        this.onLanguagesLoad,
        this.messageHandler.handleError
      )
    );
  };

  onLanguagesLoad = data => {
    var { languages } = this.state;
    if (data && data._embedded && data._embedded.content) {
      languages = data._embedded.content;
    } else {
      languages = [];
    }
    this.setState({ languages: languages });
  };

  loadPartyData = () => {
    this.prepareCall(
      this.partyService.getEntityById(
        UserSession.getUser().partyId,
        this.onPartyLoad,
        this.messageHandler.handleError
      )
    );
  };

  onPartyLoad = data => {
    this.setState({ party: { ...data }, oldParty: { ...data } });
  };

  save = e => {
    e.preventDefault();

    this.prepareCall(
      this.partyService.patchEntity(
        this.state.party,
        this.state.oldParty,
        this.onPartySaved,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onPartySaved = party => {
    this.messageHandler.handleSuccess({ text: messages.settingsSaveSuccess });

    this.onPartyLoad(party);
    const user = UserSession.getUser();
    user.party = party;
    UserSession.setUser(user);
    this.props.handleClose();

    if (!LocalizationUtil.isLocalized(labels)) {
      window.location.reload();
    }
  };

  onChange = event => {
    let { party } = this.state;
    CommonUtil.setDeepOnStringPath(party, event.target.id, event.target.value);
    this.setState({
      party
    });
  };

  render() {
    return (
      <Settings
        show={this.props.show}
        handleClose={this.props.handleClose}
        onSave={this.save}
        onChange={this.onChange}
        languages={this.state.languages}
        party={this.state.party}
      />
    );
  }
}

export default SettingsContainer;
